export class BrandingImageSettings {
  name: string;
  label: string;
  url: string;
  type: string;
  mimeTypes: string[];
  size: BrandingImageDimension;

  constructor(name: string, label: string, url: string, type: string, mimeTypes: string[], width: number, height: number) {
    this.name = name;
    this.label = label;
    this.url = url;
    this.type = type;
    this.mimeTypes = mimeTypes;
    this.size = new BrandingImageDimension(width, height);
  }
}

export class BrandingImageDimension {
  width: number;
  height: number;

  constructor(w: number, h: number) {
    this.width = w;
    this.height = h;
  }
}
